import { gameDuration } from '@/core/constants/game'

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    history.scrollRestoration = 'manual'
  }
  const loop = useLoop()
  const gameStore = useBrickGameStore()
  const userStore = useBrickUserStore()

  let lastTime = 0

  useSocket('balance_change', (data) => {
    const gameSlug = data.category.replace('original:', '') as keyof typeof gameDuration
    const mark = data.mark

    let delay
    switch (gameSlug) {
      case 'baccarat':
        delay = gameDuration.baccarat
        break
      case 'cases':
        delay = () => {
          return gameStore.caseAnimationDelay
        }
        break
      case 'dice':
        delay = gameStore.diceAnimationDelay || gameDuration[gameStore.diceFastAnimation ? 'diceFast' : 'dice']
        break
      case 'inventory_item':
        delay = 0
        break
      case 'roulette':
        delay = gameDuration.roulette
        break
      case 'upgrader':
        delay = gameStore.upgraderAnimationDelay
        break
      default:
        break
    }
    if (data.category === 'WIN_WHEEL_SPIN') {
      delay = 6
    }

    const isDeferredGame = gameSlug === 'plinko' || gameSlug === 'plinko2'

    let called = false
    const time = Date.now()
    const updateBalanceOnce = (): void => {
      if (called) {
        return
      }
      called = true
      if (mark === 'add') {
        gameStore.shiftBalanceChange(gameSlug)
      }

      if (isDeferredGame) {
        const pending = gameStore.balanceChangeList.get(gameSlug)?.length ?? 0
        if (pending > 0) {
          const before = data.balance_before
          const after = data.balance_after
          const balanceDelta = after.main.balance - before.main.balance
          const bonusDelta = (after.bonus?.balance ?? 0) - (before.bonus?.balance ?? 0)
          const totalBalance = Math.max(0, userStore.balance + userStore.balanceBonus + balanceDelta + bonusDelta)
          const balance = Math.min(totalBalance, Math.max(0, userStore.balance + balanceDelta))

          userStore.setBalance({
            balance,
            balanceBonus: totalBalance - balance,
            balanceInventory:
              userStore.balanceInventory + ((after.main.inventory ?? 0) - (before.main.inventory ?? 0)),
            balanceLocked: userStore.balanceLocked + (after.main.balance_locked - before.main.balance_locked),
          })
          if (after.event_coins) {
            userStore.setBalanceEvent(after.event_coins)
          }
          return
        }
      }

      if (time < lastTime) {
        return
      }
      lastTime = time
      userStore.setBalance({
        balance: data.balance_after.main.balance,
        balanceBonus: data.balance_after.bonus?.balance,
        balanceInventory: data.balance_after.main.inventory,
        balanceLocked: data.balance_after.main.balance_locked,
      })
      if (data.balance_after.event_coins) {
        userStore.setBalanceEvent(data.balance_after.event_coins)
      }
    }

    if (mark === 'add') {
      gameStore.addBalanceChange(gameSlug, updateBalanceOnce)
    }

    loop.add(updateBalanceOnce, {
      delay: mark === 'add' ? delay || gameDuration[gameSlug] || 0 : 0,
      group: gameSlug,
    })
  })
})
